import { createAsyncThunk } from '@reduxjs/toolkit';

import deleteDealership from 'services/dealerships/deleteDealership';

export const deleteDealershipAction = createAsyncThunk('dealerships/deleteDealership', async (id) => {
  const result = await deleteDealership(id);

  return result;
});
